import React, { Component } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { MESSAGES } from '../constants/Constants';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        
        // Log the error to your error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    handleReset = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null
        });
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container className="mt-5">
                    <Alert variant="danger">
                        <Alert.Heading>Oops! Something went wrong</Alert.Heading>
                        <p>{MESSAGES.ERROR.GENERAL}</p>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <pre className="mt-3 p-3 bg-light">
                                {this.state.error.toString()}
                            </pre>
                        )}
                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button 
                                variant="outline-danger"
                                onClick={() => window.location.reload()}
                            >
                                Refresh Page
                            </Button>
                            <Button 
                                variant="danger"
                                className="ms-2"
                                onClick={this.handleReset}
                            >
                                Try Again
                            </Button>
                        </div>
                    </Alert>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 